import { createFileRoute } from "@tanstack/react-router";
import AdminSecurity from "@/pages/AdminSecurity";

export const Route = createFileRoute("/admin/security/")({
  component: AdminSecurity,
});
